import { useState, useEffect } from "react";
import { observer } from "mobx-react";
import styles from "./index.module.scss";

interface CounterProps {
  value: number;
  minAmount: number;
  maxAmount: number;
  stock: number;
  disabled?: boolean;
  onChange: (value: number) => void;
  immediately?: boolean;
}

interface MyState {
  value: number;
  reduceDisable: boolean;
  addDisable: boolean;
}

export const debounce = <T extends (...args: unknown[]) => void>(
  func: T,
  wait: number,
  immediate?: boolean,
) => {
  let timeout: NodeJS.Timeout | null = null;

  return function (this: unknown, ...args: Parameters<T>) {
    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      timeout = null;
      if (!immediate) {
        func.apply(this, args);
      }
    }, wait);

    if (immediate && !timeout) {
      func.apply(this, args);
    }
  };
};

const CounterItem: React.FC<CounterProps> = observer(
  ({ value, minAmount, maxAmount, stock, disabled = false, onChange, immediately = true }) => {
    const [state, setState] = useState<MyState>({
      value,
      reduceDisable: false,
      addDisable: false,
    });

    const maxLocal = stock ? Math.min(stock, maxAmount) : maxAmount;

    useEffect(() => {
      // if (state.value !== value) {
      //   computeCounter();
      // }
      computeCounter();
    }, [state.value]); // 依赖于 state.value

    const computeCounter = () => {
      let localValue = state.value;
      // @ts-ignore
      if(localValue === '') {
          // onchange 时，-1 表示内容清空，blur时用 min值
          onChange(-1);
          return
      }
      if (state.value >= maxLocal) {
        setState((prevState) => ({
          ...prevState,
          addDisable: true,
        }));
        localValue = maxLocal;
        setState((prevState) => ({
          ...prevState,
          value: localValue,
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          addDisable: false,
        }));
      }
      if (state.value <= minAmount) {
        setState((prevState) => ({
          ...prevState,
          reduceDisable: true,
        }));
        localValue = minAmount;
        setState((prevState) => ({
          ...prevState,
          value: localValue,
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          reduceDisable: false,
        }));
      }
      if (state.value !== value) {
        onChange(state.value);
      }
      // onChange(state.value);
    };

    const update = debounce(() => {
      computeCounter();
    }, 500);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      let val = parseInt(e.target.value);
      if (isNaN(val)) {
        // @ts-ignore
        val = '';
      }
      setState((prevState) => ({
        ...prevState,
        value: val,
      }));
      // update();
    };

    const handleReduce = () => {
      if (state.reduceDisable || disabled) {
        return;
      }
      setState((prevState) => ({
        ...prevState,
        value: prevState.value - 1,
      }));
    };

    const handleAdd = () => {
      if (state.addDisable || disabled) {
        return;
      }
      setState((prevState) => ({
        ...prevState,
        value: prevState.value + 1,
      }));
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      const val = e.target.value;

      if (!val) {
        // setState((prevState) => ({
        //   ...prevState,
        //   value: 1,
        // }));
        // onChange(state.value);
        setState((prevState) => ({
          ...prevState,
          value: minAmount, // 设置为最小值
        }));
        // onChange(minAmount); // 直接传递最小值
      }
    };

    return (
      <div className={`${styles.counter} ${styles["counter-row"]}`}>
        <i
          className={`${styles["counter-input-icon"]} ${styles["counter-reduce"]} ${state.reduceDisable || disabled ? styles["counter-reduce-disable"] : styles["counter-reduce-enable"]}`}
          onClick={debounce(handleReduce, 100)}
        ></i>
        <input
          type="number"
          value={state.value}
          onBlur={handleBlur}
          disabled={disabled}
          onChange={handleChange}
        />
        <i
          className={`${styles["counter-input-icon"]} ${styles["counter-add"]} ${state.addDisable || disabled ? styles["counter-add-disable"] : styles["counter-add-enable"]}`}
          onClick={debounce(handleAdd, 100)}
        ></i>
      </div>
    );
  },
);

export default CounterItem;
